import script from "./CreateSessionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSessionDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateSessionDialog.vue?vue&type=style&index=0&id=7f836f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f836f38"]])

export default __exports__